package br.com.texeratx.boardgametimeapp.ui.screens.matches

data class MatchesFilter(
    val selectedGameIds: Set<Long> = emptySet(),
    val selectedPlayerIds: Set<Long> = emptySet(),
    val minDuration: Int? = null,
    val maxDuration: Int? = null,
    val startDateApi: String? = null,
    val endDateApi: String? = null
) {
    fun hasActiveFilters(): Boolean {
        return selectedGameIds.isNotEmpty() ||
                selectedPlayerIds.isNotEmpty() ||
                minDuration != null ||
                maxDuration != null ||
                !startDateApi.isNullOrBlank() ||
                !endDateApi.isNullOrBlank()
    }
}
